<template>
  <section class="services-section">
    <div class="container">
      <div class="section-header">
        <span class="section-badge">השירותים שלנו</span>
        <h2 class="section-title">כל מה שהעסק שלך צריך</h2>
      </div>

      <div class="services-grid">
        <div class="service-card service-card-featured">
          <div class="service-number">01</div>
          <h3 class="service-title">קטלוג מוצרים דיגיטלי</h3>
          <p class="service-desc">
            גישה לקטלוג מוצרים עדכני עם מידע מפורט, מחירים ותמונות. הזמנה קלה ומהירה דרך המערכת.
          </p>
          <ul class="service-features">
            <li>חיפוש חכם</li>
            <li>מועדפים</li>
            <li>היסטוריית הזמנות</li>
          </ul>
        </div>

        <div class="service-card">
          <div class="service-number">02</div>
          <h3 class="service-title">מעקב הזמנות</h3>
          <p class="service-desc">
            מעקב בזמן אמת אחר סטטוס ההזמנות שלך, מרגע ההזמנה ועד לקבלה בעסק.
          </p>
        </div>

        <div class="service-card">
          <div class="service-number">03</div>
          <h3 class="service-title">דוחות וניתוח</h3>
          <p class="service-desc">
            כלי ניתוח מתקדמים לניהול הרכישות, מעקב הוצאות וקבלת החלטות מבוססות נתונים.
          </p>
        </div>

        <div class="service-card">
          <div class="service-number">04</div>
          <h3 class="service-title">תמיכה אישית</h3>
          <p class="service-desc">
            צוות תמיכה מקצועי זמין לכל שאלה או בקשה. סוכן שטח אישי ללקוחות פעילים.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="./styles/section-header.css" scoped></style>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.services-section {
  padding: var(--spacing-xl) 0;
  background: var(--bg-secondary);
}

@media (min-width: 768px) {
  .services-section {
    padding: var(--spacing-3xl) 0;
  }
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-md);
}

@media (min-width: 768px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-lg);
  }
}

.service-card {
  padding: var(--spacing-lg);
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  position: relative;
  transition: all var(--transition-fast);
}

@media (min-width: 768px) {
  .service-card {
    padding: var(--spacing-xl);
  }
}

.service-card:hover {
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 8px 24px rgba(245, 158, 11, 0.15);
}

.service-card-featured {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-color: transparent;
  color: white;
}

@media (min-width: 768px) {
  .service-card-featured {
    grid-row: span 2;
  }
}

.service-card-featured .service-title {
  color: white;
}

.service-card-featured .service-desc {
  color: rgba(255, 255, 255, 0.8);
}

.service-number {
  font-size: 3rem;
  font-weight: var(--font-weight-bold);
  color: rgba(30, 41, 59, 0.1);
  position: absolute;
  top: var(--spacing-sm);
  left: var(--spacing-md);
  line-height: 1;
}

@media (min-width: 768px) {
  .service-number {
    font-size: 4rem;
    top: var(--spacing-md);
    left: var(--spacing-lg);
  }
}

.service-card-featured .service-number {
  color: rgba(255, 255, 255, 0.1);
}

.service-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
  position: relative;
}

@media (min-width: 768px) {
  .service-title {
    font-size: var(--font-size-xl);
    margin-bottom: var(--spacing-sm);
  }
}

.service-desc {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
  position: relative;
}

.service-features {
  margin-top: var(--spacing-md);
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

@media (min-width: 768px) {
  .service-features {
    margin-top: var(--spacing-lg);
    gap: var(--spacing-sm);
  }
}

.service-features li {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.9);
}

.service-features li::before {
  content: '';
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(245, 158, 11, 0.5);
}
</style>
